/* eslint-disable */
import config from 'config';
import uaParser from 'ua-parser-js';
import moment from 'moment';

import constants from './const';
import Cookies from 'js-cookie';

export default {
  validateEmail: (email) => {
    var re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },

  addClass: (elementEvent, className) => {
    let elementClass = elementEvent.target.attributes.getNamedItem('class');
    elementClass.value += ' ' + className;
  },

  removeClass: (elementEvent, className) => {
    let elementClass = elementEvent.target.attributes.getNamedItem('class');
    elementClass.value = elementClass.value.replace(new RegExp(className, 'g'), '').trim();
  },

  formatAmountKAT: (amount) => {
    return Number(amount) / 10 ** config.eth.KATT.DECIMALS;
  },

  getContentFromUrl: (url) => {
    try {
      const request = new XMLHttpRequest();
      request.open('GET', url, false);
      request.send(null);
      return request.responseText;
    } catch (err) {
      return '';
    }
  },

  csvToJSON: (csv) => {
    var lines = csv ? csv.split('\n') : [];
    var result = [];
    var headers = lines.length && lines[0] ? lines[0].split(',') : [];
    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i] ? lines[i].split(',') : [];
      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j];
      }
      result.push(obj);
    }
    return JSON.stringify(result).replace(/\\n|\\r/g, ''); //JSON
  },

  charLimiter: (str, length, ending) => {
    // TODO: check str must be a string, length must be an unsigned int, ending must be a string. Use try catch
    if (length == null) {
      length = 100;
    }
    if (ending == null) {
      ending = '...';
    }
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  },

  isValidEmail: (email) => {
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-_]+\.[A-Za-z]{2,}$/gm;
    return email && regex.test(email);
  },

  isMobile: () => {
    const ua = uaParser(window.navigator.userAgent),
      device = ua.device,
      type = device.type;

    return type ? type === 'mobile' || type === 'tablet' : false;
  },

  showBlinkMessage: () => {
    let blockchainAlerts = document.getElementsByClassName('blockchain-alert');
    if (!blockchainAlerts || !blockchainAlerts.length) return;
    let blockchainAlert = blockchainAlerts[0];
    blockchainAlert.scrollIntoView();
    blockchainAlert.classList.add('blink');
    if (window.timeout) clearTimeout(window.timeout);
    window.timeout = setTimeout(() => {
      blockchainAlert.classList.remove('blink');
    }, 3000);
  },

  formatNumber: (value, decimal = 2, defaultValue = '') => {
    if (!value) {
      return defaultValue;
    }
    const numValue = parseFloat(value).toFixed(decimal);
    return `${numValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },

  getNumberSuffix: (value) => {
    switch (value) {
      case 1:
        return `${value}st`;
      case 2:
        return `${value}nd`;
      case 3:
        return `${value}rd`;
      default:
        return `${value}th`;
    }
  },

  formalizeDatetime(date, showTime = true) {
    if (!date) return null;
    let mlist = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let ordinal_suffix_of = function (i) {
      var j = i % 10,
        k = i % 100;
      if (j === 1 && k !== 11) {
        return i + 'st';
      }
      if (j === 2 && k !== 12) {
        return i + 'nd';
      }
      if (j === 3 && k !== 13) {
        return i + 'rd';
      }
      return i + 'th';
    };
    date = new Date(date);
    const getHours = ('0' + date.getHours()).slice(-2);
    const getMinutes = ('0' + date.getMinutes()).slice(-2);
    const time = ` ${getHours}:${getMinutes}`;

    return `${mlist[date.getMonth()]} ${ordinal_suffix_of(date.getDate())}${showTime ? time : ''}`;
  },

  parseQueryString: function (locationSearch) {
    var str = locationSearch;
    var objURL = {};
    str.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function ($0, $1, $2, $3) {
      objURL[$1] = $3;
    });
    return objURL;
  },

  getNFirstLettersFromName: (name, n = 2) => {
    var splitName = name ? name.split(' ') : [];
    var nFirstLetters = '';

    for (var i = 0; i < n; i++) {
      if (splitName[i]) nFirstLetters += splitName[i][0].toUpperCase();
      else break;
    }

    return nFirstLetters;
  },

  capitalize: (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  },

  getThumbnailYoutubeLink: (linkYoutube, thumbnailSize = 0) => {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = linkYoutube.match(regExp);
    var video_id = match && match[7].length == 11 ? match[7] : false;
    if (video_id) {
      var thumbnailYoutube = 'http://img.youtube.com/vi/' + video_id + '/' + thumbnailSize + '.jpg';
    }
    return thumbnailYoutube ? thumbnailYoutube : '';
  },

  lowerCaseAndReplaceSpaces: (string, replaceSpaceTo = '') => {
    return string.replace(/\s+/g, replaceSpaceTo).toLowerCase();
  },

  validatePhoneNumber(dialCode, value) {
    const data = value ? value.trim() : '';
    const reg = new RegExp(`^\\+${dialCode}\\d{4,15}$`);
    return reg.test(data);
  },

  copyToClipboard(text) {
    const element = document.createElement('textarea');
    element.value = text;
    element.setAttribute('readonly', '');
    element.style.position = 'absolute';
    element.style.left = '-9999px';
    document.body.appendChild(element);
    element.select();
    document.execCommand('copy');
    document.body.removeChild(element);
  },

  sortByKey(key1, key2) {
    return (objectA, objectB) => {
      if (objectA[key1] > objectB[key1]) {
        return -1;
      }
      if (objectA[key1] < objectB[key1]) {
        return 1;
      }

      if (key2) {
        if (objectA[key2] > objectB[key2]) return -1;
        if (objectA[key2] < objectB[key2]) return 1;
      }
      return 0;
    };
  },

  getUserExperienceLabel(experience) {
    for (const obj of constants.USER_EXPERIENCES) {
      if (obj.value === experience) {
        return obj.label;
      }
    }
    return experience;
  },

  getUserFullName({ firstName, lastName, name }) {
    return [firstName, lastName].join(' ').trim() || (name || '').trim();
  },

  getPublicProfilePathname(publicUsername) {
    return `${constants.PREFIX_PROFILE_PATHNAME}${publicUsername}`;
  },

  getTimestampWithTimezone(timezone = 7) {
    const currentTime = new Date().getTime();
    const minutesTimezoneOfset = new Date().getTimezoneOffset();
    return currentTime + (minutesTimezoneOfset + timezone * 60) * 60 * 1000;
  },

  getMedalFromCredits(credit) {
    if (credit > 5000) return 'DIAMOND';
    if (credit > 1000) return 'GOLD';
    if (credit > 300) return 'SILVER';
    return 'BRONZE';
  },
  getLevelFromKarma(karma) {
    if (karma > 5000000) return 'LEADER';
    if (karma > 1000000) return 'MASTER';
    if (karma > 300000) return 'SENIOR';
    return 'JUNIOR';
  },

  formatPrice({ price, type = 'VND' }) {
    switch (type) {
      case 'VND':
        return new Intl.NumberFormat('vi-VN').format(price) + 'VND';
      case 'USD':
        return new Intl.NumberFormat('en-US').format(price) + 'USD';
      default:
        return new Intl.NumberFormat('vi-VN').format(price) + 'VND';
    }
  },

  getTimelineData({ bounty }) {
    const oneDay = 24 * 60 * 60 * 1000;
    const createdDate = new Date(bounty.createdAt);
    const startDate = new Date(bounty.startDate);
    const now = new Date();
    var diffDays = parseInt((startDate.getTime() - now.getTime()) / oneDay, 10);
    if (diffDays < 0) diffDays = 0;
    var diffDaysFromCreateDateToStartDate = startDate.getTime() - createdDate.getTime();
    var diffDaysFromCurrentDateToStartDate = now.getTime() - createdDate.getTime();
    var percent = 0;
    percent = (diffDaysFromCurrentDateToStartDate / diffDaysFromCreateDateToStartDate).toFixed(1) * 100 + '%';
    return { diffDays, percent };
  },

  getTimelineDataTokenSale({ saleCampaign }) {
    const oneDay = 24 * 60 * 60 * 1000;
    const createdDate = new Date(saleCampaign.createdAt);
    const startDate = new Date(saleCampaign.vestingStartTime);
    const now = new Date();
    var diffDays = parseInt((startDate.getTime() - now.getTime()) / oneDay, 10);
    if (diffDays < 0) diffDays = 0;
    var diffDaysFromCreateDateToStartDate = startDate.getTime() - createdDate.getTime();
    var diffDaysFromCurrentDateToStartDate = now.getTime() - createdDate.getTime();
    var percent = 0;
    percent = (diffDaysFromCurrentDateToStartDate / diffDaysFromCreateDateToStartDate).toFixed(1) * 100 + '%';
    return { diffDays, percent };
  },

  checkMinWordCount({ string, count }) {
    let s = string;
    s = s.replace(/(^\s*)|(\s*$)/gi, '');
    s = s.replace(/[ ]{2,}/gi, ' ');
    s = s.replace(/\n /, '\n');
    return s && s.split(' ').length >= count;
  },

  toCamel(s) {
    return s.replace(/([-_][a-z])/gi, ($1) => {
      return $1.toUpperCase().replace('-', '').replace('_', '');
    });
  },

  isURL(str) {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i',
    ); // fragment locator
    return pattern.test(str);
  },

  isValidURL(str) {
    const pattern = new RegExp(
      '^(?!mailto:)(?:(?:http|https)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
      'i',
    );
    return pattern.test(str);
  },

  setValueLikeKeyObject(object) {
    const method = {};
    Object.keys(object).forEach((key) => {
      method[key] = key;
    });
    return method;
  },

  createImage: (url) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener('load', () => resolve(image));
      image.addEventListener('error', (error) => reject(error));
      image.src = url;
    });
  },

  shortenString: (string) => {
    if (!string) return '';
    if (string.length <= 15) return string;
    return string.replace(string.substring(6, string.length - 6), '...');
  },

  viewEtherScan: (tx) => {
    const netId = config.eth.NETWORK.toString();
    var network = '';
    switch (netId) {
      case '1':
        network = '';
        break;
      case '3':
        network = 'ropsten.';
        break;
      case '4':
        network = 'rinkeby.';
        break;
      case '42':
        network = 'kovan.';
        break;
      case '5':
        network = 'goerli.';
        break;
      default:
        network = '';
    }
    const scannedLink = 'https://' + network + 'etherscan.io/tx/' + tx;
    window.open(scannedLink, '_blank');
  },

  saveToCookie: (key, data, expires = 365) => {
    if (!key || !data) {
      return;
    }
    let secure = true;
    const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
    if (env === 'development') {
      secure = false;
    }
    Cookies.set(key, data, { expires: expires, sameSite: 'Strict', secure: secure });
  },

  removeCookie: (key) => {
    if (!key) {
      return;
    }
    Cookies.remove(key);
  },

  getCookie: (key) => {
    if (!key) {
      return;
    }
    return Cookies.get(key);
  },
};

export const formatRating = (value) => {
  const num = Number(value);
  if (isNaN(num)) return '0.0';
  return num.toFixed(1);
};

export const maskUserName = (name) => {
  if (!name || typeof name !== 'string') return '?';
  const s = name.trim();
  if (s.length === 0) return '*';
  if (s.length === 1) return s;
  return s[0] + '***' + s[s.length - 1];
};

export const getAgeAndBirthYear = (dob) => {
  try {
    if (!dob) return null;
    if (typeof dob !== 'string' || dob.length < 4) return null;
    if (/^\d{4}$/.test(dob)) {
      const year = parseInt(dob);
      const age = moment().year() - year;
      return { age, year };
    }
    const dobObj = moment(dob, 'DD/MM/YYYY');
    if (dobObj.isValid()) {
      const age = moment().diff(dobObj, 'years');
      return { age, year: dobObj.year() };
    }
    return null;
  } catch (error) {
    return null;
  }
};
